import createIcon from '../../createIcon';

/**
 * @component @name SettingsBackupRestore
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNSAxMkMxNS41IDEwLjkgMTQuNiAxMCAxMy41IDEwQzEyLjQgMTAgMTEuNSAxMC45IDExLjUgMTJDMTEuNSAxMy4xIDEyLjQgMTQgMTMuNSAxNEMxNC42IDE0IDE1LjUgMTMuMSAxNS41IDEyWk0xMy41IDNDOC41MyAzIDQuNSA3LjAzIDQuNSAxMkgxLjVMNS41IDE2TDkuNSAxMkg2LjVDNi41IDguMTMgOS42MyA1IDEzLjUgNUMxNy4zNyA1IDIwLjUgOC4xMyAyMC41IDEyQzIwLjUgMTUuODcgMTcuMzcgMTkgMTMuNSAxOUMxMS45OSAxOSAxMC41OSAxOC41MSA5LjQ0IDE3LjdMOC4wMiAxOS4xNEM5LjU0IDIwLjMgMTEuNDQgMjEgMTMuNSAyMUMxOC40NyAyMSAyMi41IDE2Ljk3IDIyLjUgMTJDMjIuNSA3LjAzIDE4LjQ3IDMgMTMuNSAzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SettingsBackupRestore = createIcon('SettingsBackupRestore', [
  [
    'path',
    {
      d: 'M15.5 12C15.5 10.9 14.6 10 13.5 10C12.4 10 11.5 10.9 11.5 12C11.5 13.1 12.4 14 13.5 14C14.6 14 15.5 13.1 15.5 12ZM13.5 3C8.53 3 4.5 7.03 4.5 12H1.5L5.5 16L9.5 12H6.5C6.5 8.13 9.63 5 13.5 5C17.37 5 20.5 8.13 20.5 12C20.5 15.87 17.37 19 13.5 19C11.99 19 10.59 18.51 9.44 17.7L8.02 19.14C9.54 20.3 11.44 21 13.5 21C18.47 21 22.5 16.97 22.5 12C22.5 7.03 18.47 3 13.5 3Z',
      key: 'p4rxhi',
    },
  ],
]);

export default SettingsBackupRestore;
